/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Meloman_FInputs */

const en_testimonial_meloman_f = /** @type {(inputs: Testimonial_Meloman_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect for converting large texts into audio. And when they added support for parallel reading along with the audio—I was blown away! It became significantly faster, easier, and clearer to absorb textbooks.`)
};

const es_testimonial_meloman_f = /** @type {(inputs: Testimonial_Meloman_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecto para convertir textos largos en audio. Y cuando agregaron soporte para lectura paralela junto con el audio, ¡me quedé asombrado! Se volvió significativamente más rápido, fácil y claro absorber los libros de texto.`)
};

/**
* | output |
* | --- |
* | "Perfect for converting large texts into audio. And when they added support for parallel reading along with the audio—I was blown away! It became significantl..." |
*
* @param {Testimonial_Meloman_FInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_meloman_f = /** @type {((inputs?: Testimonial_Meloman_FInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Meloman_FInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_meloman_f(inputs)
	return en_testimonial_meloman_f(inputs)
});